import Axios from 'axios';

const PAGE = 'productPage';

const ADD_TO_CART_OPTION_SELECTOR = '#options .product-card__info .product-card__button';
const ADD_TO_CART_SERVICE_SELECTOR = '#service .product-card__button';
const ADD_TO_CART_COMPLETE_SOLUTION_SELECTOR = '.popup__window .cys-card-button .btn';
const FIND_RESELLER_NOT_STICKED_SELECTOR =
    '.product-description-wrapper:not(.product-description-block__sticked)  .product-description__reseller-text';
const FIND_RESELLER_STICKED_SELECTOR =
    '.product-description-block__sticked .product-description__reseller-text';
const FIND_RESELLER_SELECTOR = '.product-description__reseller-text';
const BUY_FROM_PARTNER_SELECTOR = '.ps-widget .ps-online-buy-button.available';
const SHOW_ALL_SELECTOR = '.our_partners__link';
const PRODUCT_REGISTRATION_SELECTOR =
    '.quick-product-links__list li[data-item-name="Product-Registration"]';
const SOFTWARE_DOWNLOAD_SELECTOR =
    '#software_and_firmware .software-firmware-product-card__download';
const MAIN_DOWNLOAD_CTA_BTN_SELECTOR =
    '.product-description-wrapper:not(.product-description-block__sticked)  #download_btn__background';
const MAIN_FLOATING_DOWNLOAD_BTN_SELECTOR =
    '.product-description-block__sticked #download_btn__background';
const MAIN_FLOATING_DOWNLOAD_MOB_BTN_SELECTOR =
    '#apc-usc #download_btn__background .product-description__download_btn';
const PRINT_TECHNICAL_SPECIFICATION_SELECTOR = '#technical_specification .fast-action__name';
const REVIEW_TITLE_SELECTOR =
    '.product-description__special-review-section .bv_button_buttonMinimalist';
const REVIEW_TAB_SELECTOR = '#ratings_and_reviews .bv-write-review';
const ADD_FAVORITE_SELECTOR_ENGAGEMENT =
    '.product-description__add-to-favorites-section:not(.add_to_favourites_state_added) .product-description__add-to-favorites-text';
const ADD_REMOVE_FAVORITE =
    '.product-description__add-to-favorites-section .product-description__add-to-favorites-text';
const COMPARE_SELECTOR = '.analytics-compare-now';
const QUICK_LINK_SELECTOR =
    '.quick-product-links__item[data-is-selector]  .quick-product-links__link';
const DOCUMENTATION_DOWNLOAD_BTN_SELECTOR = '#documentation .documentation .external-link';
const CHAT_SELECTOR = '.analytics-chat';
const CHAT_ONLINE_SELECTOR = '.analytics-chat-online';
const SHARE_SELECTOR =
    '.atm-s a:not([id=atic_more]), #at-expanded-menu-bd li:not(.at3winsvc_more):not(.at3winsvc_settings)';
const CHIP_LINK_SELECTOR = '.product-description__chips-links .container-select select';
const SERVICE_SELECT_SELECTOR = '#service .dd__container-select select';
const WHERE_TO_BUY_INPUT_SELECTOR = '.ps-wtb-container input.ps-map-location-textbox';
const ITEM_COMPARE_SELECTOR = '.result-list__item-comparison .form-choice';
const QUANTITY_DOWN_SELECTOR =
    '.product-description__quantity-counter-btn#btn-counter-dec:not([disabled])';
const QUANTITY_UP_SELECTOR = '.product-description__quantity-counter-btn#btn-counter-inc';
const QUICK_PRODUCT_LINK_SELECTOR = '.quick-product-links__link';
const PRODUCT_OVERVIEW_SELECTOR = '.product-description__custom-solution-text';
const PRODUCT_TAB_SELECTOR = '.pd-tabs__button';
const CHIPS_LINK_SELECTOR = '.chips-links__button:not(.chips-links__button_active)';
const VIEW_FROM_PARTNER_BTN_SELECTOR = '.ps-widget .ps-online-buy-button.unavailable';
const TAB_SHOW_MORE_SELECTOR = '.tabs-show-more';
const TECHNICAL_PRINT_SELECTOR = '.fast-action__name_print';
const TECHNICAL_DOWNLOAD_SELECTOR = '.fast-action__name_download';
const DOCUMENT_DOWNLOAD_SELECTOR =
    '#documentation .documentation-content-block__content .external-link';
const OPTION_SELECT_OPTION_SELECTOR = '#options .dd__menu .dd__item:not(.dd__item_selected)';
const OPTIONS_PRODUCT_LINK_SELECTOR = '#options .product-card__title .external-link';
const OPTIONS_HOW_TO_BUY_SELECTOR = '#options .how-to-buy__button';
const OPTION_SELECT_OPTION_MOBILE_SELECTOR = '#options .dd__container-select select';
const OPTIONS_CALL_FOR_AVAILABILITY_SELECTOR = '#options .call-for-availability';
const INCLUDED_COMPONENT_LINK_SELECTOR =
    '#included_components .included-components-item__title .external-link';
const SERVICE_LINK_SELECTOR = '#service .product-card__title .external-link';
const SERVICE_SELECT_OPTION_SELECTOR = '#service .dd__menu .dd__item:not(.dd__item_selected)';
const SERVICE_HOW_TO_BUY_SELECTOR = '#service .how-to-buy__button';
const SERVICE_CALL_FOR_AVAILABILITY_SELECTOR = '#service .call-for-availability';
const SOFTWARE_LINK_SELECTOR =
    '#software_and_firmware .software-firmware-product-card__title .external-link';
const RATING_SORT_BY_SELECTOR =
    '.bv-cleanslate .bv-dropdown .bv-dropdown-item:not(.bv-dropdown-item-selected)';
const COMPLETE_SOLUTION_CLOSE_SELECTOR = '.js-cys-container .popup__close';
const COMPLETE_SOLUTION_CONTINUE_SELECTOR = '.popup__window .cys-button-continue';
const COMPLETE_SOLUTION_CHECKOUT_SELECTOR = '.popup__window .cys-button-checkout';
const COMPLETE_SOLUTION_NAVIGATION_SELECTOR = '.popup__window .cys-card-image .slider-image-wrap';
const WHERE_TO_BUY_CLOSE_SELECTOR = '.ps-wtb-container .ps-lightbox-close';
const WHERE_TO_BUY_SEARCH_BTN_SELECTOR = '.ps-wtb-container .ps-map-location-button';
const WHERE_TO_BUY_VIEW_BTN_SELECTOR =
    '.ps-wtb-container.ps-float-box .ps-online-buy-button.ps-online-view-button';
const WHERE_TO_BUY_BTN_SELECTOR = '.ps-wtb-container.ps-float-box .ps-online-buy-button';
const BREADCRUMBS_SELECTOR = '.breadcrumbs li a[data-item-name]';

const ADD_TO_CART_SELECTOR =
    '.product-description-wrapper:not(.product-description-block__sticked) .product-description__add-to-cart-btn';
const ADD_TO_CART_FIXED_SELECTOR =
    '.product-description-wrapper.product-description-block__sticked .product-description__add-to-cart-btn';

const ADD_TO_CART_STICKED_MOB_SELECTOR =
    '#apc-usc #add-to-cart__background .product-description__add-to-cart-btn';
const SOFTWARE_PURCHASE_BTN = '#software_and_firmware .purchase-block__purchase-CD';
const SOFTWARE_HOW_TO_BUY_BTN = '#software_and_firmware .how-to-buy__button';
const SOFTWARE_CARD_SELECTOR = '.software-firmware-product-card';
const PRODUCT_CARD_SELECTOR = '.product-card';
const RUN_TIME_LOAD_SELECTOR = '.runtime-calculator .runtime-calculator__input';
const QUANTITY_INPUT_SELECTOR = '.product-description__price-section #qty_field';
const COMPARE_CLOSE_SELECTOR = '.analytics-compare-close';
const RATING_SELECTOR = '.bv_main_container .bv_numReviews_text, .bv_main_container .bv_avgRating ';
const IMAGE_WRAPPER_SELECTOR =
    '.product-description__main-block__mobile .image-block:not(.swiper-slide-active), .product-description__image-slider .swiper-wrapper  .image-block:not(.image-block_state_active), .zoom-popup__left-bar__scroll-container .image-block:not(.image-block_state_active)';
const IMAGE_VIEW_SELECTOR =
    '.product-description__image-section:not(.product-description__image-section_default-hidden) .product-description__main-block, .product-description__image-section:not(.product-description__image-section_default-hidden) .product-description__main-block__mobile .image-block.swiper-slide-active';
const SHOW_PRODUCT_OVERVIEW_SELECTOR = 'input.overview-load__button';
const SHOW_DOCUMENTATION_SELECTOR = 'button.software-firmware-product-card__show-docs';
const SOFTWARE_DOWNLOAD_DOCUM_SELECTOR =
    '#software_and_firmware .software-firmware-docs-block__data a';
const RECENTLY_VIEWED_SELECTOR = '.recently-viewed-carousel__container a.swiper-slide';
const RECENTLY_VIEWED_REMOVE_SELECTOR =
    '.recently-viewed-carousel__container a.swiper-slide .recently-viewed-product__remove';
const ADD_FAVORITE_SIGNIN_SELECTOR = '.add-to-fav__buttons .btn-se_color_blue';
const ADD_FAVORITE_CREATE_ACC_SELECTOR = '.add-to-fav__buttons .btn-se_color_blue_invert';
const ADD_FAVORITE_CLOSE_SELECTOR = '.popup__window.add-to-fav .popup__close';
const HOW_TO_BUY_MAIN_SELECTOR =
    '.product-description-wrapper:not(.product-description-block__sticked) .how-to-buy__button';
const HOW_TO_BUY_FLOATING_SELECTOR = '.product-description-block__sticked .how-to-buy__button';
const HOW_TO_BUY_FLOATING_MOB_SELECTOR = '#apc-usc .how-to-buy__button';
const PRODUCT_OVERVIEW_VIDEO_SELECTOR = '.wc-fragment img.wc-video, .wc-fragment .wc-play-button';
const RBK_SELECTOR = '.external-link.rbk-link';
const RUNTIME_GRAPH_SELECTOR = '.runtimeGraphUrl a';
const RUNTIME_CHART_SELECTOR = '.runtimeChartUrl a';
const EFFICIENCY_SELECTOR = '.efficiencyGraphUrl a';
const EXTENDED_RUN_OPTION_SELECTOR = '.externalUrl a';
const VIEW_ALTERNATIVE_SELECTOR =
    '.product-description-wrapper:not(.product-description-block__sticked) #substitute_btn__background a';
const VIEW_ALTERNATIVE_STICKED_SELECTOR =
    '.product-description-wrapper.product-description-block__sticked #substitute_btn__background a';
const VIEW_ALTERNATIVE_STICKED_MOB_SELECTOR = '#apc-usc #substitute_btn__background a';
const CUP_ClOSE_BUTTON_SELECTOR = '.cup__close';
const CUP_PRODUCT_LINK_SELECTOR = '.cup__title';
const CUP_FILE_LINK_SELECTOR = '.cup-footer__link';

const DOWNLOAD = 'Download';
const ADD_TO_CART = 'Add-to-cart';
const HOW_TO_BUY = 'How-to-buy';
const CALL_FOR_INFO = 'Call-for-info';
const CALL_FOR_AVAILABILITY_LABEL = 'Call-for-availability';
const VIEW_ALTERNATIVE = 'View-alternative';

const USER_CATEGORY_ID_PATH = '/rest/model/schneider/profile/UserLookupActor/userInfo';

const { apcLogService } = window;
const safeWrap = prop => (...args) => {
    if (!apcLogService) return null;
    return apcLogService[prop](...args);
};

const matchThisOrChildren = safeWrap('matchThisOrChildren');
const getClosest = safeWrap('getClosest');
const preload = safeWrap('preload');
const format = safeWrap('format');
const setVariables = safeWrap('setVariables');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');
const setPageReady = safeWrap('setPageReady');
const getFileId = safeWrap('getFileId');

const isSoftWare = !!document.querySelector('#common-strings[data-is-software]');

let productSubCategory = '';
let productName = '';
let productId = '';

const getCategory = level => {
    const el = document.querySelector(
        `.breadcrumbs__list .breadcrumbs__item:nth-last-child(${level}) a[data-item-name]`
    );
    return el ? el.dataset.itemName || '' : '';
};

const getCurrency = () => {
    const currencyMeta = document.querySelector('meta[name="tagging-currency"]');
    return currencyMeta ? currencyMeta.content : '';
};

const isPriceSpider = () =>
    !!document.querySelector('.product-description__price-section_wrapper .ps-widget__block');

const getRootVariables = () => {
    const priceSection = document.querySelector('.product-description__price-section_wrapper');
    const commonStringsBlock = document.querySelector('#common-strings');
    const commonStrings = commonStringsBlock ? commonStringsBlock.dataset : {};
    const { taxFree = '', taxIncluded = '', productDiscount = '', productStock = '' } = priceSection
        ? priceSection.dataset
        : {};
    const { skuBrand: brand = '' } = commonStrings;
    const badgeContainer = document.querySelector('.product-description__badges-section');
    const categoryLvl3 = getCategory(3);
    const categoryLvl4 = getCategory(4);

    return {
        product_id: productId,
        product_variant: badgeContainer ? '1' : '0',
        product_name: productName,
        product_brand: brand,
        product_discount: productDiscount,
        product_price_tax_included: taxIncluded,
        product_price_tax_free: taxFree,
        product_currency: getCurrency(),
        product_stock: productStock,
        product_category_1: categoryLvl4,
        product_category_2: categoryLvl3,
        product_category_3: productSubCategory,
        product_category_4: `Direct-ecomm_${+taxFree || +taxIncluded ? 'yes' : 'no'}`,
        product_category_5: `Indirect-ecomm_${isPriceSpider() ? 'yes' : 'no'}`,
        product_category_6: badgeContainer ? badgeContainer.dataset['productCategory-6'] || '' : '',
    };
};

const getVariables = elem => {
    const {
        itemName = '',
        productId: id = '',
        priceNoTax = '',
        priceValue = '',
        productDiscount = '',
    } = elem.dataset;
    return {
        product_id: id,
        product_variant: '',
        product_name: itemName,
        product_brand: '',
        product_discount: productDiscount,
        product_price_tax_included: priceValue,
        product_price_tax_free: priceNoTax,
        product_currency: getCurrency(),
        product_stock: '1',
        product_category_1: '',
        product_category_2: '',
        product_category_3: '',
        product_category_4: `Direct-ecomm_${+priceNoTax || +priceValue ? 'yes' : 'no'}`,
        product_category_5: '',
        product_category_6: '',
    };
};

const getCysProductsVariables = () => {
    const products = [...document.querySelectorAll('#cys-products .slick-track .cys-card')];
    return products.map(el => getVariables(el));
};

const checkExistClasses = (elem, classes = []) => classes.some(cls => elem.classList.contains(cls));

const getTypeOfImageFromSwiper = block => {
    const model3D = ['is-3d-item', 'is3d'];
    const video = ['is-video-item', 'isVideo'];
    if (checkExistClasses(block, model3D)) {
        return '3D-model';
    }
    if (checkExistClasses(block, video)) {
        return 'video';
    }

    return 'image';
};
const getPositionImageFromSwiper = block => {
    const parentElem = block.parentElement;
    const children = [...parentElem.children];
    return children.indexOf(block) + 1;
};

const getShareSelectionName = target => {
    const block = getClosest(target, '.atm-s a:not([id=atic_more]) , .at-expanded-menu li');
    const nameBlock = block.querySelector('.at-label, .at-expanded-menu-button-label');
    let selectedOption = nameBlock ? format(nameBlock.textContent) : '';
    if (block.classList.contains('at3winsvc_favorites')) {
        selectedOption = 'Favorites';
    }
    if (block.classList.contains('at3winsvc_print')) {
        selectedOption = 'Print';
    }
    return selectedOption;
};
const getDocumentType = (url = '') => {
    const doctype = (url.match(/(p_enDocType=)([^&]+)/) || [])[2] || '';
    return format(window.decodeURI(doctype));
};
const getSelectedGroups = tabIdSelector => {
    const elements = document.querySelectorAll(
        `${tabIdSelector} .dd__container:not(.dd_container_state_hide)`
    );
    return [...elements].map(el => el.dataset.selected || '');
};
const getSoftwareSectionName = target => {
    const tab = getClosest(target, '.software-firmware-tab');
    return tab ? tab.dataset.itemName : '';
};
const getVideoName = target => {
    const parent = getClosest(target, '.wc-media-inner-wrap');
    if (parent) {
        const block = parent.querySelector('img.wc-video');
        return format(block.title);
    }
    return '';
};
const getProductIdFromUrl = (url = '') => url.match(/.*\/([^?]+)/)[1];

class PDP_Analytics {
    constructor() {
        this.BLOCK = null;
        const node = document.querySelector('#cys-products .slider');
        if (node) {
            const config = { childList: true };
            const observer = new MutationObserver(this.productsObserver);
            observer.observe(node, config);
        }
    }

    init() {
        this.BLOCK = document.querySelector('body');
        if (this.BLOCK) {
            this.BLOCK.addEventListener('click', this.handlePdpPage, true);
            this.BLOCK.addEventListener('change', this.handleChangePdpPage, true);
            this.BLOCK.addEventListener('click', this.handleEngagementClick, true);
            this.BLOCK.addEventListener('click', this.handleSalesInsight, true);
        }
    }

    productsObserver(mutationsList) {
        try {
            // eslint-disable-next-line
            for (const mutation of mutationsList) {
                if (
                    mutation.type === 'childList' &&
                    mutation.addedNodes.length === 1 &&
                    mutation.addedNodes[0].classList.contains('slick-track')
                ) {
                    apcLogService(`${PAGE}.productsChangedSalesInsight.click`, {
                        target: document,
                        productDetails: getCysProductsVariables(),
                    });
                    return;
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    sendSalesInsight(target, productDetails) {
        apcLogService(`${PAGE}.addCardSalesInsight.click`, {
            target,
            productDetails,
            cartId: (window.tc_vars && window.tc_vars.cart_id) || '',
        });
    }

    handleSalesInsight = e => {
        const { target } = e;
        let block = null;
        let productDetails = null;
        if (
            matchThisOrChildren(target, `${ADD_TO_CART_SELECTOR} , ${ADD_TO_CART_FIXED_SELECTOR}`)
        ) {
            const qty = document.querySelector(QUANTITY_INPUT_SELECTOR).value;
            productDetails = {
                ...getRootVariables(),
                product_qty: qty,
            };
            this.sendSalesInsight(target, productDetails);
        } else if (
            matchThisOrChildren(
                target,
                `${ADD_TO_CART_OPTION_SELECTOR} , ${ADD_TO_CART_SERVICE_SELECTOR}, ${SOFTWARE_PURCHASE_BTN}`
            )
        ) {
            block = getClosest(target, `${PRODUCT_CARD_SELECTOR}, ${SOFTWARE_CARD_SELECTOR}`);
            productDetails = {
                ...getVariables(block),
                product_qty: '1',
            };
            this.sendSalesInsight(target, productDetails);
        } else if (matchThisOrChildren(target, ADD_TO_CART_COMPLETE_SOLUTION_SELECTOR)) {
            block = getClosest(target, '.cys-card');
            productDetails = {
                ...getVariables(block),
                product_qty: '1',
            };
            this.sendSalesInsight(target, productDetails);
        }
    };

    handleEngagementClick = e => {
        const { target } = e;
        let block = null;
        let desiredEventTarget = null;
        if (matchThisOrChildren(target, FIND_RESELLER_NOT_STICKED_SELECTOR)) {
            block = getClosest(target, FIND_RESELLER_SELECTOR);
            apcLogService(`${PAGE}.findResellerEngagement.click`, {
                target: block,
                productId,
                url: document.location.href,
            }); // 141 engagement
        } else if (matchThisOrChildren(target, FIND_RESELLER_STICKED_SELECTOR)) {
            block = getClosest(target, FIND_RESELLER_SELECTOR);
            apcLogService(`${PAGE}.findResellerEngagementSticked.click`, {
                target: block,
                productId,
                url: document.location.href,
            }); // 142 engagement
        } else if (matchThisOrChildren(target, WHERE_TO_BUY_BTN_SELECTOR)) {
            block = getClosest(target, '.ps-online-sellers .ps-online-seller-select');
            const img = block.querySelector('.ps-online-seller-cell img');
            apcLogService(`${PAGE}.whereToBuyBuyButtonEngagement.click`, {
                target,
                brand: format(img ? img.title : ''),
                productId,
                url: document.location.href,
            }); // engagement 121
        } else if (matchThisOrChildren(target, BUY_FROM_PARTNER_SELECTOR)) {
            desiredEventTarget = getClosest(target, '.ps-online-buy-button');
            block = getClosest(target, '.ps-online-sellers .ps-online-seller-select');
            const partner = block.querySelector('div small');
            apcLogService(`${PAGE}.buyFromPartnerEngagement.click`, {
                target: desiredEventTarget,
                brand: format(partner ? partner.textContent : ''),
                productId,
                url: document.location.href,
            }); // engagement 122
        } else if (matchThisOrChildren(target, SHOW_ALL_SELECTOR)) {
            apcLogService(`${PAGE}.showAllEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 122
        } else if (matchThisOrChildren(target, PRODUCT_REGISTRATION_SELECTOR)) {
            apcLogService(`${PAGE}.productRegistration.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 43
        } else if (matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            apcLogService(`${PAGE}.addToCardEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 99
        } else if (
            matchThisOrChildren(target, ADD_TO_CART_FIXED_SELECTOR) ||
            matchThisOrChildren(target, ADD_TO_CART_STICKED_MOB_SELECTOR)
        ) {
            apcLogService(`${PAGE}.addToCardStickedEngagement.click`, {
                productId,
                url: document.location.href,
            }); // engagement 100
        } else if (matchThisOrChildren(target, ADD_TO_CART_COMPLETE_SOLUTION_SELECTOR)) {
            block = getClosest(target, '.cys-carousel .cys-card.slick-slide');
            apcLogService(`${PAGE}.completeSolutionAddToCardEngagement.click`, {
                target,
                productId,
                url: document.location.href,
                productIdCys: block.dataset.productId || '',
            }); // engagement 101
        } else if (matchThisOrChildren(target, ADD_TO_CART_OPTION_SELECTOR)) {
            desiredEventTarget = getClosest(target, '.product-card__button');
            block = getClosest(target, PRODUCT_CARD_SELECTOR);
            apcLogService(`${PAGE}.optionAddToCardEngagement.click`, {
                target: desiredEventTarget,
                url: document.location.href,
                productId,
                productIdDetailed: block.dataset.productId,
            }); // engagement 102
        } else if (matchThisOrChildren(target, ADD_TO_CART_SERVICE_SELECTOR)) {
            block = getClosest(target, PRODUCT_CARD_SELECTOR);
            apcLogService(`${PAGE}.serviceAddToCardEngagement.click`, {
                target,
                url: document.location.href,
                productId,
                productIdDetailed: block.dataset.productId,
            }); // engagement 103
        } else if (matchThisOrChildren(target, SOFTWARE_DOWNLOAD_SELECTOR)) {
            block = getClosest(target, SOFTWARE_CARD_SELECTOR);
            apcLogService(`${PAGE}.softwareDownloadEngagement.click`, {
                target,
                url: document.location.href,
                productIdDetailed: block.dataset.productId,
            }); // engagement 17
        } else if (matchThisOrChildren(target, MAIN_DOWNLOAD_CTA_BTN_SELECTOR)) {
            apcLogService(`${PAGE}.mainCtaDownloadEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement main download cta
        } else if (
            matchThisOrChildren(target, MAIN_FLOATING_DOWNLOAD_BTN_SELECTOR) ||
            matchThisOrChildren(target, MAIN_FLOATING_DOWNLOAD_MOB_BTN_SELECTOR)
        ) {
            apcLogService(`${PAGE}.mainFloatingDownloadEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement main download floating
        } else if (matchThisOrChildren(target, PRINT_TECHNICAL_SPECIFICATION_SELECTOR)) {
            apcLogService(`${PAGE}.technicalPrintDownloadEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 32 technical print
        } else if (matchThisOrChildren(target, REVIEW_TITLE_SELECTOR)) {
            apcLogService(`${PAGE}.reviewTitleEngagement.click`, {
                target: block,
                productId,
                url: document.location.href,
            }); // engagement 50 review title
        } else if (matchThisOrChildren(target, REVIEW_TAB_SELECTOR)) {
            apcLogService(`${PAGE}.reviewTabEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 51 review tab
        } else if (matchThisOrChildren(target, ADD_FAVORITE_SELECTOR_ENGAGEMENT)) {
            apcLogService(`${PAGE}.addToFavoriteEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 94 add to favorite
        } else if (matchThisOrChildren(target, COMPARE_SELECTOR)) {
            apcLogService(`${PAGE}.compareNowEngagement.click`, {
                target,
                skuId: productId,
                url: document.location.href,
            }); // engagement 94  compare now
        } else if (matchThisOrChildren(target, QUICK_LINK_SELECTOR)) {
            block = getClosest(target, '.quick-product-links__item');
            apcLogService(`${PAGE}.quickSelectorsLinkEngagement.click`, {
                target,
                productId,
                name: block.dataset.itemName || '',
                url: document.location.href,
            }); // engagement 6  quick links
        } else if (matchThisOrChildren(target, DOCUMENTATION_DOWNLOAD_BTN_SELECTOR)) {
            block = getClosest(target, '.documentation');
            apcLogService(`${PAGE}.documentDownloadEngagement.click`, {
                target,
                productId,
                documentType: block.dataset.itemName || '',
                documentId: getFileId(target.href),
                url: document.location.href,
            }); // engagement 137  document download
        } else if (matchThisOrChildren(target, CHAT_ONLINE_SELECTOR)) {
            apcLogService(`${PAGE}.chatEngagement.click`, {
                target,
                productId,
                url: document.location.href,
            }); // engagement 151 chat
        } else if (matchThisOrChildren(target, SHARE_SELECTOR)) {
            apcLogService(`${PAGE}.shareEngagement.click`, {
                target,
                productId,
                selectedOption: getShareSelectionName(target),
                url: document.location.href,
            }); // engagement 11 share
        } else if (matchThisOrChildren(target, SOFTWARE_PURCHASE_BTN)) {
            block = getClosest(target, SOFTWARE_CARD_SELECTOR);
            apcLogService(`${PAGE}.softwareAddToCardEngagement.click`, {
                target,
                url: document.location.href,
                productId,
                productIdDetailed: block.dataset.productId,
            });
        } else if (matchThisOrChildren(target, SOFTWARE_DOWNLOAD_DOCUM_SELECTOR)) {
            this.softwareDownloadDocumEngagement(target);
        } else if (matchThisOrChildren(target, PRODUCT_OVERVIEW_VIDEO_SELECTOR)) {
            this.overviewVideoEngagement(target);
        }
    };

    handleChangePdpPage = e => {
        const { target } = e;
        let block = null;
        if (matchThisOrChildren(target, CHIP_LINK_SELECTOR)) {
            [block] = target.selectedOptions;
            this.chipLink(target, block);
        } else if (matchThisOrChildren(target, SERVICE_SELECT_SELECTOR)) {
            [block] = target.selectedOptions;
            this.tabSelectOption(block, 'Services');
        } else if (matchThisOrChildren(target, WHERE_TO_BUY_INPUT_SELECTOR)) {
            const { value } = target;
            apcLogService(`${PAGE}.whereToBuySearchInput.click`, {
                target,
                skuId: productId,
                keyword: format(value),
            }); // 2 where to buy search
        } else if (matchThisOrChildren(target, ITEM_COMPARE_SELECTOR)) {
            apcLogService(`${PAGE}.resultItemCompare.check`, {
                target,
                isSoftWare,
                productId,
                checked: target.checked,
            }); //  compare
        } else if (matchThisOrChildren(target, RUN_TIME_LOAD_SELECTOR)) {
            apcLogService(`${PAGE}.runTimeLoad.click`, {
                target,
                optionResult: target.value,
                productId,
            }); // 6
        } else if (matchThisOrChildren(target, OPTION_SELECT_OPTION_MOBILE_SELECTOR)) {
            [block] = target.selectedOptions;
            this.tabSelectOption(block, 'Options');
        }
    };

    handlePdpPage = e => {
        const { target } = e;
        let block = null;
        if (matchThisOrChildren(target, QUANTITY_DOWN_SELECTOR)) {
            this.quantity(target, 'down');
        } else if (matchThisOrChildren(target, QUANTITY_UP_SELECTOR)) {
            this.quantity(target, 'up');
        } else if (matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            this.mainCTA(target, ADD_TO_CART);
        } else if (matchThisOrChildren(target, ADD_REMOVE_FAVORITE)) {
            this.addRemoveFavorite(target);
        } else if (matchThisOrChildren(target, FIND_RESELLER_SELECTOR)) {
            this.findReseller(target);
        } else if (matchThisOrChildren(target, QUICK_PRODUCT_LINK_SELECTOR)) {
            this.additionalDocument(target);
        } else if (matchThisOrChildren(target, PRODUCT_OVERVIEW_SELECTOR)) {
            this.productOverview(target);
        } else if (matchThisOrChildren(target, SHARE_SELECTOR)) {
            this.productShare(target);
        } else if (matchThisOrChildren(target, PRODUCT_TAB_SELECTOR)) {
            this.productTab(target);
        } else if (matchThisOrChildren(target, CHIPS_LINK_SELECTOR)) {
            block = getClosest(target, '.chips-links__button');
            this.chipLink(target, block);
        } else if (matchThisOrChildren(target, SHOW_ALL_SELECTOR)) {
            this.showAll(target);
        } else if (matchThisOrChildren(target, BUY_FROM_PARTNER_SELECTOR)) {
            this.buyFromPartner(target);
        } else if (matchThisOrChildren(target, VIEW_FROM_PARTNER_BTN_SELECTOR)) {
            this.viewFromPartner(target);
        } else if (
            matchThisOrChildren(
                target,
                `${ADD_TO_CART_FIXED_SELECTOR}, ${ADD_TO_CART_STICKED_MOB_SELECTOR}`
            )
        ) {
            this.mainCTAFloating(target, ADD_TO_CART);
        } else if (matchThisOrChildren(target, TAB_SHOW_MORE_SELECTOR)) {
            block = getClosest(target, TAB_SHOW_MORE_SELECTOR);
            const tabId = getClosest(target, '.pd-tabs__tab').id;
            const tabButton = document.querySelector(`.pd-tabs__list button[data-tab=${tabId}]`);
            const tab = getClosest(tabButton, '.pd-tabs__item');
            apcLogService(`${PAGE}.showMore.click`, {
                target: block,
                skuId: productId,
                tabName: tab ? tab.dataset.itemName : '',
            }); // 2 2nd
        } else if (matchThisOrChildren(target, TECHNICAL_PRINT_SELECTOR)) {
            this.technicalPrintProduct(target);
        } else if (matchThisOrChildren(target, TECHNICAL_DOWNLOAD_SELECTOR)) {
            this.technicalDownloadProduct(target);
        } else if (matchThisOrChildren(target, DOCUMENT_DOWNLOAD_SELECTOR)) {
            this.documentationDownload(target);
        } else if (matchThisOrChildren(target, OPTION_SELECT_OPTION_SELECTOR)) {
            this.tabSelectOption(target, 'Options');
        } else if (matchThisOrChildren(target, OPTIONS_PRODUCT_LINK_SELECTOR)) {
            this.optionProductClick(target);
        } else if (matchThisOrChildren(target, ADD_TO_CART_OPTION_SELECTOR)) {
            this.optionCTA(target, ADD_TO_CART);
        } else if (matchThisOrChildren(target, OPTIONS_HOW_TO_BUY_SELECTOR)) {
            this.optionCTA(target, HOW_TO_BUY);
        } else if (matchThisOrChildren(target, OPTIONS_CALL_FOR_AVAILABILITY_SELECTOR)) {
            this.optionCTA(target, CALL_FOR_INFO);
        } else if (matchThisOrChildren(target, INCLUDED_COMPONENT_LINK_SELECTOR)) {
            this.includedComponentsItem(target);
        } else if (matchThisOrChildren(target, SERVICE_LINK_SELECTOR)) {
            this.serviceProductClick(target);
        } else if (matchThisOrChildren(target, SERVICE_SELECT_OPTION_SELECTOR)) {
            this.tabSelectOption(target, 'Services');
        } else if (matchThisOrChildren(target, SERVICE_HOW_TO_BUY_SELECTOR)) {
            this.servicesCTA(target, HOW_TO_BUY);
        } else if (matchThisOrChildren(target, ADD_TO_CART_SERVICE_SELECTOR)) {
            this.servicesCTA(target, ADD_TO_CART);
        } else if (matchThisOrChildren(target, SERVICE_CALL_FOR_AVAILABILITY_SELECTOR)) {
            this.servicesCTA(target, CALL_FOR_AVAILABILITY_LABEL);
        } else if (matchThisOrChildren(target, SOFTWARE_LINK_SELECTOR)) {
            this.softwareItem(target);
        } else if (matchThisOrChildren(target, SOFTWARE_DOWNLOAD_SELECTOR)) {
            this.softwareCTA(target, DOWNLOAD);
        } else if (matchThisOrChildren(target, SOFTWARE_PURCHASE_BTN)) {
            this.softwareCTA(target, ADD_TO_CART);
        } else if (matchThisOrChildren(target, REVIEW_TAB_SELECTOR)) {
            this.writeReviewBottom(target);
        } else if (matchThisOrChildren(target, RATING_SORT_BY_SELECTOR)) {
            this.ratingSortBy(target);
        } else if (matchThisOrChildren(target, COMPLETE_SOLUTION_CLOSE_SELECTOR)) {
            this.completeSolutionClose(target);
        } else if (matchThisOrChildren(target, COMPLETE_SOLUTION_CONTINUE_SELECTOR)) {
            this.completeSolutionContinue(target);
        } else if (matchThisOrChildren(target, COMPLETE_SOLUTION_CHECKOUT_SELECTOR)) {
            this.completeSolutionCheckout(target);
        } else if (matchThisOrChildren(target, COMPLETE_SOLUTION_NAVIGATION_SELECTOR)) {
            this.completeSolutionNavigationItem(target);
        } else if (matchThisOrChildren(target, ADD_TO_CART_COMPLETE_SOLUTION_SELECTOR)) {
            this.completeSolutionAddToCard(target);
        } else if (matchThisOrChildren(target, WHERE_TO_BUY_CLOSE_SELECTOR)) {
            this.whereToBuyClose(target);
        } else if (matchThisOrChildren(target, WHERE_TO_BUY_SEARCH_BTN_SELECTOR)) {
            this.whereToBuySearchButton(target);
        } else if (
            matchThisOrChildren(
                target,
                `${WHERE_TO_BUY_VIEW_BTN_SELECTOR}, ${WHERE_TO_BUY_BTN_SELECTOR}`
            )
        ) {
            this.whereToBuyButtons(target);
        } else if (matchThisOrChildren(target, REVIEW_TITLE_SELECTOR)) {
            this.reviewTitle(target);
        } else if (matchThisOrChildren(target, BREADCRUMBS_SELECTOR)) {
            this.breadCrumbs(target);
        } else if (matchThisOrChildren(target, COMPARE_SELECTOR)) {
            this.compareNow(target);
        } else if (matchThisOrChildren(target, COMPARE_CLOSE_SELECTOR)) {
            this.compareClose(target);
        } else if (matchThisOrChildren(target, CHAT_SELECTOR)) {
            this.chatOpen(target);
        } else if (matchThisOrChildren(target, RATING_SELECTOR)) {
            this.rating(target);
        } else if (matchThisOrChildren(target, IMAGE_WRAPPER_SELECTOR)) {
            this.imageWrapper(target);
        } else if (matchThisOrChildren(target, IMAGE_VIEW_SELECTOR)) {
            this.imageView(target);
        } else if (matchThisOrChildren(target, SHOW_PRODUCT_OVERVIEW_SELECTOR)) {
            this.showProductOverview(target);
        } else if (matchThisOrChildren(target, SHOW_DOCUMENTATION_SELECTOR)) {
            this.showDocumentation(target);
        } else if (matchThisOrChildren(target, SOFTWARE_DOWNLOAD_DOCUM_SELECTOR)) {
            this.softwareDownloadDocum(target);
        } else if (matchThisOrChildren(target, RECENTLY_VIEWED_REMOVE_SELECTOR)) {
            this.recentlyViewedRemove(target);
        } else if (matchThisOrChildren(target, RECENTLY_VIEWED_SELECTOR)) {
            this.recentlyViewed(target);
        } else if (matchThisOrChildren(target, ADD_FAVORITE_SIGNIN_SELECTOR)) {
            this.addFavoriteSignIn(target);
        } else if (matchThisOrChildren(target, ADD_FAVORITE_CREATE_ACC_SELECTOR)) {
            this.addFavoriteCreateAcc(target);
        } else if (matchThisOrChildren(target, ADD_FAVORITE_CLOSE_SELECTOR)) {
            this.addFavoritesClose(target);
        } else if (matchThisOrChildren(target, MAIN_DOWNLOAD_CTA_BTN_SELECTOR)) {
            this.mainCTA(target, DOWNLOAD);
        } else if (matchThisOrChildren(target, HOW_TO_BUY_MAIN_SELECTOR)) {
            this.mainCTA(target, HOW_TO_BUY);
        } else if (
            matchThisOrChildren(
                target,
                `${HOW_TO_BUY_FLOATING_SELECTOR}, ${HOW_TO_BUY_FLOATING_MOB_SELECTOR}`
            )
        ) {
            this.mainCTAFloating(target, HOW_TO_BUY);
        } else if (
            matchThisOrChildren(
                target,
                `${MAIN_FLOATING_DOWNLOAD_BTN_SELECTOR}, ${MAIN_FLOATING_DOWNLOAD_MOB_BTN_SELECTOR}`
            )
        ) {
            this.mainCTAFloating(target, DOWNLOAD);
        } else if (matchThisOrChildren(target, PRODUCT_OVERVIEW_VIDEO_SELECTOR)) {
            this.overviewVideo(target);
        } else if (matchThisOrChildren(target, RBK_SELECTOR)) {
            this.replacementBattery(target);
        } else if (matchThisOrChildren(target, SOFTWARE_HOW_TO_BUY_BTN)) {
            this.softwareCTA(target, HOW_TO_BUY);
        } else if (matchThisOrChildren(target, RUNTIME_GRAPH_SELECTOR)) {
            this.runtimeGraph(target);
        } else if (matchThisOrChildren(target, RUNTIME_CHART_SELECTOR)) {
            this.runtimeChart(target);
        } else if (matchThisOrChildren(target, EFFICIENCY_SELECTOR)) {
            this.efficiency(target);
        } else if (matchThisOrChildren(target, EXTENDED_RUN_OPTION_SELECTOR)) {
            this.runOptions(target);
        } else if (matchThisOrChildren(target, CUP_ClOSE_BUTTON_SELECTOR)) {
            this.cupPopupClose(target);
        } else if (matchThisOrChildren(target, CUP_PRODUCT_LINK_SELECTOR)) {
            this.cupPopupItem(target);
        } else if (matchThisOrChildren(target, CUP_FILE_LINK_SELECTOR)) {
            this.cupPopupLink(target);
        } else if (matchThisOrChildren(target, VIEW_ALTERNATIVE_SELECTOR)) {
            const alternativeId = getProductIdFromUrl(target.href);
            this.mainCTA(target, `${VIEW_ALTERNATIVE}_${alternativeId}`);
        } else if (
            matchThisOrChildren(
                target,
                `${VIEW_ALTERNATIVE_STICKED_SELECTOR}, ${VIEW_ALTERNATIVE_STICKED_MOB_SELECTOR}`
            )
        ) {
            const alternativeId = getProductIdFromUrl(target.href);
            this.mainCTAFloating(target, `${VIEW_ALTERNATIVE}_${alternativeId}`);
        }
    };

    cupPopupClose(target) {
        apcLogService(`${PAGE}.cupPopupClose.click`, {
            target,
            productId,
        });
    }

    cupPopupItem(target) {
        const selectedProductId = getProductIdFromUrl(target.href);
        apcLogService(`${PAGE}.cupPopupItem.click`, {
            target,
            productId,
            selectedProductId,
        });
    }

    cupPopupLink(target) {
        apcLogService(`${PAGE}.cupPopupLink.click`, {
            target,
            productId,
        });
    }

    runOptions(target) {
        apcLogService(`${PAGE}.runOptions.click`, {
            target,
            productId,
        });
    }

    efficiency(target) {
        apcLogService(`${PAGE}.efficiency.click`, {
            target,
            productId,
        });
    }

    runtimeChart(target) {
        apcLogService(`${PAGE}.runtimeChart.click`, {
            target,
            productId,
        });
    }

    runtimeGraph(target) {
        apcLogService(`${PAGE}.runtimeGraph.click`, {
            target,
            productId,
        });
    }

    ratingSortBy(target) {
        apcLogService(`${PAGE}.ratingSortBy.click`, {
            target,
            productId,
            sortType: format(target.textContent),
        }); // rating sort by
    }

    quantity(target, type) {
        apcLogService(`${PAGE}.quantity.click`, {
            target,
            productId,
            type,
        }); // 1
    }

    includedComponentsItem(target) {
        const link = getClosest(target, '.external-link');
        const block = getClosest(target, '.included-components-block');
        const { itemName = '', itemId = '' } = link.dataset || {};
        apcLogService(`${PAGE}.includedComponentsItem.click`, {
            target: link,
            productId,
            itemId,
            sectionName: block ? block.dataset.blockName : '',
            itemName,
        });
    }

    whereToBuyClose(target) {
        const block = getClosest(target, '.ps-lightbox-close');
        apcLogService(`${PAGE}.whereToBuyClose.click`, {
            target: block,
            productId,
        }); // 1 where to buy close
    }

    whereToBuyButtons(target) {
        const block = getClosest(target, '.ps-online-sellers .ps-online-seller-select');
        const img = block.querySelector('.ps-online-seller-cell img');
        const type = getClosest(target, WHERE_TO_BUY_BTN_SELECTOR) ? 'Buy' : 'View';
        apcLogService(`${PAGE}.whereToBuyButtons.click`, {
            target,
            productId,
            type,
            brand: format(img ? img.title : ''),
        });
    }

    whereToBuySearchButton(target) {
        const block = getClosest(target, '.ps-map-location-button');
        const { value } = getClosest(target, '.ps-input-holder').querySelector('input');
        apcLogService(`${PAGE}.whereToBuySearchButton.click`, {
            target: block,
            productId,
            keyword: format(value),
        }); // 3 where to buy search button
    }

    viewFromPartner(target) {
        const desiredEventTarget = getClosest(target, '.ps-online-buy-button');
        const block = getClosest(target, '.ps-online-sellers .ps-online-seller-select');
        const partner = block.querySelector('div small');
        apcLogService(`${PAGE}.viewFromPartner.click`, {
            target: desiredEventTarget,
            productId,
            partner: format(partner ? partner.textContent : ''),
        }); // 14 view
    }

    productTab(target) {
        const block = getClosest(target, '.pd-tabs__item');
        apcLogService(`${PAGE}.productTab.click`, {
            target,
            productId,
            tabName: block.dataset.itemName || '',
        }); // 9
    }

    compareClose(target) {
        apcLogService(`${PAGE}.compareClose.click`, {
            target,
            productId,
        });
    }

    compareNow(target) {
        const { compareCount = '' } = target.dataset;
        apcLogService(`${PAGE}.compareNow.click`, {
            target,
            productId,
            count: compareCount,
        });
    }

    breadCrumbs(target) {
        const block = getClosest(target, 'a[data-item-name]');
        const { itemName = '', itemType = '' } = (block && block.dataset) || {};
        apcLogService(`${PAGE}.breadCrumbs.click`, {
            target,
            productId,
            itemName,
            categoryType: itemType,
        }); // breadCrumbs
    }

    reviewTitle(target) {
        apcLogService(`${PAGE}.reviewTitle.click`, {
            target,
            productId,
        }); //  review title
    }

    softwareItem(target) {
        const block = getClosest(target, SOFTWARE_CARD_SELECTOR);
        const { itemName = '', productId: softwareProductId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.softwareItem.click`, {
            target,
            productId,
            softwareProductId,
            itemName,
            sectionName: getSoftwareSectionName(target),
        }); // software item
    }

    documentationDownload(target) {
        const block = getClosest(target, DOCUMENT_DOWNLOAD_SELECTOR);
        const section = getClosest(target, '.documentation[data-item-name]');
        const url = block.href;
        apcLogService(`${PAGE}.documentationDownload.click`, {
            target: block,
            productId,
            documentType: getDocumentType(url),
            documentId: getFileId(url),
            sectionName: section ? section.dataset.itemName : '',
        }); // 1 3rd
    }

    technicalDownloadProduct(target) {
        apcLogService(`${PAGE}.technicalDownloadProduct.click`, {
            target,
            productId,
        }); // 4 2nd
    }

    technicalPrintProduct(target) {
        apcLogService(`${PAGE}.technicalPrintProduct.click`, {
            target,
            productId,
        }); // 3 2nd
    }

    productOverview(target) {
        apcLogService(`${PAGE}.productOverview.click`, {
            target,
            productId,
        }); // 7
    }

    additionalDocument(target) {
        const block = getClosest(target, QUICK_PRODUCT_LINK_SELECTOR);
        const item = getClosest(target, '.quick-product-links__item');
        apcLogService(`${PAGE}.additionalDocument.click`, {
            target: block,
            productId,
            itemName: item.dataset.itemName || '',
            url: block.href,
        }); // 6
    }

    replacementBattery(target) {
        const block = getClosest(target, RBK_SELECTOR);
        apcLogService(`${PAGE}.replacementBattery.click`, {
            target,
            batteryId: block ? `P-${block.innerText}` : '',
            productId,
        });
    }

    productShare(target) {
        apcLogService(`${PAGE}.productShare.click`, {
            target,
            shareName: getShareSelectionName(target),
            productId,
        }); // 8
    }

    completeSolutionAddToCard(target) {
        const block = getClosest(target, '.cys-carousel .cys-card.slick-slide');
        apcLogService(`${PAGE}.completeSolutionAddToCard.click`, {
            target,
            productId,
            clickedItemId: block.dataset.productId || '',
        });
    }

    completeSolutionNavigationItem(target) {
        const block = getClosest(target, '.cys-carousel .cys-card.slick-slide');
        apcLogService(`${PAGE}.completeSolutionNavigationItem.click`, {
            target,
            productId,
            clickedItemId: block.dataset.productId || '',
        });
    }

    completeSolutionCheckout(target) {
        apcLogService(`${PAGE}.completeSolutionCheckout.click`, {
            target,
            productId,
        });
    }

    completeSolutionContinue(target) {
        apcLogService(`${PAGE}.completeSolutionContinue.click`, {
            target,
            productId,
        });
    }

    completeSolutionClose(target) {
        apcLogService(`${PAGE}.completeSolutionClose.click`, {
            target,
            productId,
        }); // 1 complete solution close
    }

    overviewVideoEngagement(target) {
        apcLogService(`${PAGE}.overviewVideoEngagement.click`, {
            target,
            productId,
            videoName: getVideoName(target),
            url: document.location.href,
        });
    }

    overviewVideo(target) {
        apcLogService(`${PAGE}.overviewVideo.click`, {
            target,
            productId,
            videoName: getVideoName(target),
        });
    }

    chipLink(target, block) {
        const categoryBlock = getClosest(target, '.chips-links__block');
        apcLogService(`${PAGE}.chipLink.click`, {
            target: block,
            productId,
            optionCategory: categoryBlock.dataset.itemName || '',
            clickedItem: block.dataset.itemName || '',
        }); // 10 11 12
    }

    buyFromPartner(target) {
        const desiredEventTarget = getClosest(target, '.ps-online-buy-button');
        const block = getClosest(target, '.ps-online-sellers .ps-online-seller-select');
        const partner = block.querySelector('div small');
        apcLogService(`${PAGE}.buyFromPartner.click`, {
            target: desiredEventTarget,
            productId,
            partner: format(partner ? partner.textContent : ''),
        });
    }

    showAll(target) {
        apcLogService(`${PAGE}.showAllPartners.click`, {
            target,
            productId,
        });
    }

    mainCTAFloating(target, type) {
        apcLogService(`${PAGE}.mainCTAFloating.click`, {
            target,
            productId,
            type,
        });
    }

    mainCTA(target, type) {
        apcLogService(`${PAGE}.mainCTA.click`, {
            target,
            productId,
            type,
        });
    }

    findReseller(target) {
        const block = getClosest(target, FIND_RESELLER_SELECTOR);
        apcLogService(`${PAGE}.findReseller.click`, {
            target: block,
            productId,
            url: block.href,
        }); // 5
    }

    addFavoritesClose(target) {
        apcLogService(`${PAGE}.addFavoritesClose.click`, {
            target,
            productId,
        });
    }

    addFavoriteCreateAcc(target) {
        apcLogService(`${PAGE}.addFavoriteCreateAcc.click`, {
            target,
            productId,
        });
    }

    addFavoriteSignIn(target) {
        apcLogService(`${PAGE}.addFavoriteSignIn.click`, {
            target,
            productId,
        });
    }

    addRemoveFavorite(target) {
        const block = getClosest(target, '.product-description__add-to-favorites-text');
        const removed = !!getClosest(target, '.add_to_favourites_state_added');
        apcLogService(`${PAGE}.addRemoveFavorite.click`, {
            target: block,
            productId,
            removed,
        }); // 4
    }

    recentlyViewedRemove(target) {
        const block = getClosest(target, RECENTLY_VIEWED_SELECTOR);
        const { itemName = '', productId: selectedId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.recentlyViewedRemove.click`, {
            target,
            productId,
            itemName,
            selectedId,
        });
    }

    recentlyViewed(target) {
        const block = getClosest(target, RECENTLY_VIEWED_SELECTOR);
        const { itemName = '', productId: selectedId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.recentlyViewed.click`, {
            target,
            productId,
            itemName,
            selectedId,
        });
    }

    writeReviewBottom(target) {
        apcLogService(`${PAGE}.writeReviewBottom.click`, {
            target,
            productId,
        }); // rating review
    }

    servicesCTA(target, type) {
        const block = getClosest(target, PRODUCT_CARD_SELECTOR);
        const { itemName = '', productId: serviceProductId = '' } = block.dataset;
        const [category = ''] = getSelectedGroups('#service');
        apcLogService(`${PAGE}.servicesCTA.click`, {
            target,
            productId,
            serviceProductId,
            itemName,
            type,
            category,
        }); // 4 4th
    }

    serviceProductClick(target) {
        const block = getClosest(target, PRODUCT_CARD_SELECTOR);
        const { itemName = '', productId: serviceProductId = '' } = block.dataset;
        const [category = ''] = getSelectedGroups('#service');
        apcLogService(`${PAGE}.serviceProductClick.click`, {
            target,
            productId,
            serviceProductId,
            itemName,
            category,
        }); // 4 4th
    }

    optionCTA(target, type) {
        const block = getClosest(target, PRODUCT_CARD_SELECTOR);
        const { itemName = '', productId: optionProductId = '' } = block.dataset;
        const [category = '', subCategory = ''] = getSelectedGroups('#options');
        apcLogService(`${PAGE}.optionCTA.click`, {
            target,
            productId,
            optionProductId,
            itemName,
            type,
            category,
            subCategory,
        }); // 4 4th
    }

    optionProductClick(target) {
        const block = getClosest(target, PRODUCT_CARD_SELECTOR);
        const { itemName = '', productId: optionProductId = '' } = block.dataset;
        const [category = '', subCategory = ''] = getSelectedGroups('#options');
        apcLogService(`${PAGE}.optionProductClick.click`, {
            target,
            productId,
            optionProductId,
            itemName,
            category,
            subCategory,
        }); // 4 4th
    }

    tabSelectOption(target, tab) {
        const block = getClosest(target, '.dd__item') || target;
        const dropDown = getClosest(target, '.dd__container[data-type]');
        const type = dropDown ? dropDown.dataset.type : '';
        apcLogService(`${PAGE}.tabSelectOption.click`, {
            target: block,
            productId,
            type,
            tab,
            optionResult: block.dataset.itemName || '',
        });
    }

    softwareDownloadDocumEngagement(target) {
        const link = getClosest(target, SOFTWARE_DOWNLOAD_DOCUM_SELECTOR);
        const url = link.href || '';
        apcLogService(`${PAGE}.softwareDownloadDocumEngagement.click`, {
            target,
            productId,
            documentType: getDocumentType(url),
            documentId: getFileId(url),
            url: document.location.href,
        });
    }

    softwareDownloadDocum(target) {
        const block = getClosest(target, SOFTWARE_CARD_SELECTOR);
        const link = getClosest(target, SOFTWARE_DOWNLOAD_DOCUM_SELECTOR);
        const url = link.href || '';
        const { itemName = '', productId: softwareProductId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.softwareDownloadDocum.click`, {
            target,
            productId,
            documentType: getDocumentType(url),
            documentId: getFileId(url),
            softwareProductId,
            itemName,
            sectionName: getSoftwareSectionName(target),
        });
    }

    showDocumentation(target) {
        const block = getClosest(target, SOFTWARE_CARD_SELECTOR);
        const { itemName = '', productId: softwareProductId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.showDocumentation.click`, {
            target,
            productId,
            softwareProductId,
            itemName,
            sectionName: getSoftwareSectionName(target),
        });
    }

    softwareCTA(target, type) {
        const block = getClosest(target, SOFTWARE_CARD_SELECTOR);
        const { itemName = '', productId: softwareProductId = '' } = block.dataset || {};
        apcLogService(`${PAGE}.softwareCTA.click`, {
            target,
            productId,
            softwareProductId,
            itemName,
            type,
            sectionName: getSoftwareSectionName(target),
        });
    }

    showProductOverview(target) {
        apcLogService(`${PAGE}.showProductOverview.click`, {
            target,
            productId,
        });
    }

    imageView(target) {
        const block = getClosest(target, IMAGE_VIEW_SELECTOR);
        const type = getTypeOfImageFromSwiper(block);
        apcLogService(`${PAGE}.imageView.click`, {
            target,
            type,
            productId,
        });
    }

    imageWrapper(target) {
        const block = getClosest(target, IMAGE_WRAPPER_SELECTOR);
        const type = getTypeOfImageFromSwiper(block);
        const position = getPositionImageFromSwiper(block);
        const view = getClosest(target, '.product-description__image-slider') ? 'page' : 'pop-up';
        apcLogService(`${PAGE}.imageWrapper.click`, {
            target,
            type,
            position,
            view,
            productId,
        });
    }

    rating(target) {
        apcLogService(`${PAGE}.rating.click`, {
            target,
            productId,
        });
    }

    chatOpen(target) {
        const available = !!getClosest(target, CHAT_ONLINE_SELECTOR);
        apcLogService(`${PAGE}.chat.click`, {
            target,
            available,
            productId,
        }); // chat
    }
}
try {
    preload(PAGE);
    const priceBlock = getDefaultPageReadyPromise(`
      .async-block-wrapper .product-description__price-section-cart-wrapper,
      .async-block-wrapper .download-block-wrapper,
      .async-block-wrapper .product-description__price-section-discontinued-wrapper`);
    const userData = Axios.get(`${window.location.origin}${USER_CATEGORY_ID_PATH}`);
    const pageReadyPromise = new Promise(resolve =>
        Promise.all([priceBlock, userData])
            .then(data => resolve(data))
            .catch(() => resolve())
    );
    setPageReady(
        pageReadyPromise.then((userDataResponse = []) => {
            productSubCategory = getCategory(2);
            const [, userDataResponseData = {}] = userDataResponse;
            const { userId = '', userType = '' } = userDataResponseData.data || {};
            const commonStringsBlock = document.querySelector('#common-strings');
            const commonStrings = commonStringsBlock ? commonStringsBlock.dataset : {};
            ({ productName = '', productId = '' } = commonStrings);
            setVariables({
                page_name: `Product-page_${productId}`,
                page_level: '89',
                env_template: 'product',
                page_cat1: 'product-page',
                page_cat2: productId,
                page_cat3: productSubCategory,
                sales_insights: '1',
                price_spider: isPriceSpider() ? '1' : '0',
                user_id: userId,
                user_category: userType,
                ...getRootVariables(),
            });
            new PDP_Analytics().init();
        })
    );
} catch (err) {
    console.error(err);
}
